import { HTTP_STATUS } from './ErrorCode.model';
import { isAxiosError } from './isAxiosError.guard';

export const isForbiddenError = (error: unknown): boolean =>
  isAxiosError(error) && error.response?.status === HTTP_STATUS.FORBIDDEN;
